const RadioStyleType = {
  STANDARD: 'standard',
  BUTTON: 'button',
  ICON: 'icon',
  PILL: 'pill',
};

export default RadioStyleType;
